import { createSlice } from "@reduxjs/toolkit";

import { LOCAL_STORAGE_KEYS } from "../../Util/constants";

const initialState = {
  puzzleType: null,
  puzzle: null,
  puzzleId: null,
};
export const puzzleSlice = createSlice({
  name: LOCAL_STORAGE_KEYS.PUZZLE,
  initialState,
  reducers: {
    resetPuzzle: (state, action) => {
      return initialState;
    },
    setPuzzleType: (state, action) => {
      state.puzzleType = action.payload;
    },
    setPuzzleAndPuzzleType: (state, action) => {
      const { puzzleId, puzzle, puzzleType, edit } = action.payload;
      state.puzzle = puzzle;
      state.puzzleType = puzzleType;
      state.puzzleId = puzzleId;
      state.edit = Boolean(edit);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setPuzzleType,
  setPuzzleAndPuzzleType,
  resetPuzzle
} = puzzleSlice.actions;

export default puzzleSlice.reducer;
